import styles from './ContactForm.module.scss';

const PatientForm = ({ formData, handleChange, handleBooleanToggle }: any) => {
	return (
		<>
			<div className={styles['form-group']}>
				<label htmlFor="firstName">First name *</label>
				<input
					type="text"
					id="firstName"
					name="firstName"
					value={formData.firstName}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="lastName">Last name *</label>
				<input
					type="text"
					id="lastName"
					name="lastName"
					value={formData.lastName}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="phoneNumber">Phone number *</label>
				<input
					type="text"
					id="phoneNumber"
					name="phoneNumber"
					value={formData.phoneNumber}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="email">Email address *</label>
				<input
					type="text"
					id="email"
					name="email"
					value={formData.email}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="dateOfBirth">Date of Birth *</label>
				<input
					type="date"
					id="dateOfBirth"
					name="dateOfBirth"
					value={formData.dateOfBirth}
					onChange={handleChange}
					required
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="gender">Gender *</label>
				<select
					id="gender"
					name="gender"
					value={formData.gender}
					onChange={handleChange}
					required
					className={styles['form-select']}
				>
					<option value="" disabled>
						Select a gender
					</option>
					<option value="Male">Male</option>
					<option value="Female">Female</option>
					<option value="Other">Other</option>
				</select>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="addressLine1">Address Line 1 *</label>
				<input
					type="text"
					id="addressLine1"
					name="addressLine1"
					value={formData.addressLine1}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="city">City *</label>
				<input
					type="text"
					id="city"
					name="city"
					value={formData.city}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="county">County *</label>
				<input
					type="text"
					id="county"
					name="county"
					value={formData.county}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="postcode">Postcode *</label>
				<input
					type="text"
					id="postcode"
					name="postcode"
					value={formData.postcode}
					onChange={handleChange}
					required
					className={styles['form-select']}
				/>
			</div>

			<label>Can you travel? *</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.travel === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('travel', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.travel === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('travel', false)}
				>
					No
				</button>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="accessibilityRequirements">
					Do you have any accessibility requirements? If yes, please elaborate below. *
				</label>
				<input
					type="text"
					id="accessibilityRequirements"
					name="accessibilityRequirements"
					value={formData.accessibilityRequirements}
					onChange={handleChange}
					required
				/>
			</div>

			<div className={styles['form-group']}>
				<label htmlFor="preferredDatesForTesting">
					What are your preferred dates for testing? *
				</label>
				<small>
					Please provide at least <u>three options</u> for dates, as well as preference for{' '}
					<u>morning or afternoon</u> appointments
				</small>
				<input
					type="text"
					id="preferredDatesForTesting"
					name="preferredDatesForTesting"
					value={formData.preferredDatesForTesting}
					onChange={handleChange}
					required
				/>
			</div>

			<label htmlFor="operativeCheckStatus">Is this pre-operative or post-operative check? *</label>
			<div className={styles['checkbox-group']}>
				<label>
					<input
						type="checkbox"
						name="operativeCheckStatus"
						value="Pre-operative"
						checked={formData.operativeCheckStatus.includes('Pre-operative')}
						onChange={handleChange}
					/>
					Pre-operative
				</label>
				<label>
					<input
						type="checkbox"
						name="operativeCheckStatus"
						value="Post-operative"
						checked={formData.operativeCheckStatus.includes('Post-operative')}
						onChange={handleChange}
					/>
					Post-operative
				</label>
				<label>
					<input
						type="checkbox"
						name="operativeCheckStatus"
						value="General check"
						checked={formData.operativeCheckStatus.includes('General check')}
						onChange={handleChange}
					/>
					General check
				</label>
			</div>
		</>
	);
};

export default PatientForm;
